function clearAuthLocalStorage() {
  localStorage.removeItem('_snap_token');
  localStorage.removeItem('_profile_uid');
  localStorage.removeItem('_owner_id');
  localStorage.removeItem('_user_roles');
  localStorage.removeItem('_origin_app');
  localStorage.removeItem('snap_is_agent');
}

export default defineNuxtRouteMiddleware(async () => {
  const { status, data, signOut } = useAuth();

  if (data.value?.email?.includes('guest:')) {
    clearAuthLocalStorage();
    return await signOut({ callbackUrl: '/login' });
  }
  if (status.value === 'authenticated' || status.value === 'loading') {
    return;
  }

  clearAuthLocalStorage();
  return await navigateTo('/login');
});
